import { FunctionComponent, useState } from 'react';
import { Button, IconButton, Tabs, Dialog, Select, Table, TableRow, TableCell } from '../../tailwindcomponents';
import { Typography, Input } from '../../tailwindcomponents';
import EditColumn from '../Security/EditColumn';
import lineApi from '../../api/line';
import { AddCircle, Edit } from '../../components/icons';
import { EmployeeSearch, Collection } from '../../components';
import { HandoverMetaCard } from '../../components/Handover';
import { LineHandoverIssues, LineHandoverReturnReportObj } from '../../types/line';
import { User } from '../../types/user';
import LineHandoverMxiPackageInformation from './LineHandoverMxiPackageInformation';

interface HandoverDialogContextProps {
  allTails: Array<string>,
  lineHandoverReport: LineHandoverReturnReportObj,
  refresh: Function,
  onClose: Function,
  isLineSupervisorAdmin: Boolean
}

const HandoverDialogContext: FunctionComponent<HandoverDialogContextProps> = ({ allTails, lineHandoverReport, refresh, onClose, isLineSupervisorAdmin }) => {
  const [tabValue, setTabValue ] = useState<number>(0);
  const [editIndex, setEditIndex] = useState(-1);
  const [selectedTailNumber, setSelectedTailNumber] = useState("");
  const [selectedIssue, setSelectedIssue] = useState("");
  const [areYouSureDialogOpen, setAreYouSureDialogOpen] = useState(false);

  const generateTableBody = (row: LineHandoverIssues, index: number) => {
    return (
      editIndex === index ?
        <TableRow >
          <TableCell>{index}</TableCell>
          <TableCell>{row.created_date_text}</TableCell>
          <TableCell>
            <Select width={100} widthPercentage filter_by_text="Tail number" onSelectedItem={(e: any) => setSelectedTailNumber(e.target.value)} options={allTails} selectedItem={selectedTailNumber} />
          </TableCell>
          <TableCell>   <Input multiline={true} help_text={""} label_text={"Issue"} value={selectedIssue} onTextChange={(text: string) => setSelectedIssue(text)} type="text" width={100} /></TableCell>
          <EditColumn
            index={index}
            saveChanges={() => onModifieIssue(row.id)}
            deleteRow={() => onDeleteIssue(row.id)}
            editRow={index}
            setEditRow={(editRow: number) => { }} />
        </TableRow>
        :
        <TableRow >
          <TableCell>{index}</TableCell>
          <TableCell>{row.created_date_text}</TableCell>
          <TableCell>{row.tail_number}</TableCell>
          <TableCell>{row.issue}</TableCell>
          {lineHandoverReport.report.submitted === false && <TableCell><IconButton onClick={() => onSelectRow(row, index)}><Edit /></IconButton> </TableCell>}
        </TableRow>
    )
  }
  const onSelectRow = (row: LineHandoverIssues, index: number) => {
    setEditIndex(index);
    setSelectedIssue(row.issue);
    setSelectedTailNumber(row.tail_number);
  }
  const onAddIssue = () => {
    lineApi.AddIssue(lineHandoverReport.report.id, "", "").then(res => {
      setEditIndex(lineHandoverReport.report.issues.length + 1);
      setSelectedTailNumber("");
      setSelectedIssue("");
      refresh(lineHandoverReport.report.id);
    });
  }
  const onDeleteIssue = (issueId: number) => {
    lineApi.DeleteIssue(issueId, lineHandoverReport.report.id).then(res => {
      refresh(lineHandoverReport.report.id);
      setSelectedTailNumber("");
      setSelectedIssue("");
      setEditIndex(-1);
    });
  }
  const onModifieIssue = (issueId: number) => {
    lineApi.UpdateIssue(issueId, selectedIssue, selectedTailNumber, lineHandoverReport.report.id).then(res => {
      refresh(lineHandoverReport.report.id);
      setSelectedTailNumber("");
      setEditIndex(-1);
    });
  }
  const onAddEmployeeLabour = (user: User | null) => {
    if (!user) return;
    lineApi.AddLabour(lineHandoverReport.report.id, user.user_id).then(res => {
      refresh(lineHandoverReport.report.id);
    });
  }
  const onDeleteEmployeeLabour = (labourID: number) => {
    lineApi.DeleteLabour(lineHandoverReport.report.id, labourID).then(res => {
      refresh(lineHandoverReport.report.id);
    });
  }
  const onAddEmployeeLabourMC = (user: User | null) => {
    if (!user) return;
    lineApi.AddLabourMC(lineHandoverReport.report.id, user.user_id).then(res => {
      refresh(lineHandoverReport.report.id);
    });
  }
  const onDeleteEmployeeLabourMC = (labourID: number) => {
    lineApi.DeleteLabourMC(lineHandoverReport.report.id, labourID).then(res => {
      refresh(lineHandoverReport.report.id);
    });
  }
  const onAreYouDialogClicked = (status: boolean) => {
    if (status === true) {
      lineApi.CloseLineHandoverReport().then(res => {
        setAreYouSureDialogOpen(false);
        onClose();
      });
    } else {
      setAreYouSureDialogOpen(false);
      onClose();
    }
  }
  return (
    <div>
      <div>
        {lineHandoverReport.report.submitted === false && isLineSupervisorAdmin &&
          <div className="flex flex-wrap justify-center gap-2">
            <Button variant="text" onClick={() => setAreYouSureDialogOpen(true)} color='primary'>Finish report</Button>
          </div>}
        <HandoverMetaCard
          createdBy={lineHandoverReport.report.created_by_employee_name}
          createdDate={lineHandoverReport.report.created_date_text}
          shift={lineHandoverReport.report.shift}
          isDayShift={lineHandoverReport.report.is_day_shift === true}
        />
        <Typography text={'Issues'} align={'center'} variant='h2' />
        <Table
          headers={lineHandoverReport.report.submitted === false ? ["Created date", "Aircraft", "Issue", ""] : ["Created date", "Aircraft", "Issue"]}
          rows={lineHandoverReport.report.issues}
          generateBody={(row: any, index: number) => generateTableBody(row, index)}
          defaultRowsPerPage={25}
          pagination={false}
          skipIndexCol={false}
        />
        {lineHandoverReport.report.submitted === false && isLineSupervisorAdmin &&
          <div className="flex flex-col items-center">
            <IconButton onClick={() => onAddIssue()} className="text-success" >
              <AddCircle />
            </IconButton>
          </div>}
      </div>
      <div className="flex gap-3">
        <div className="flex-1 min-w-0">
          {lineHandoverReport.report.submitted === false && isLineSupervisorAdmin && <EmployeeSearch place_holder={"Line employees"} clearOnSelect fullUser={true} onSelectedEmployee={(employee: User | null) => onAddEmployeeLabour(employee)} inputWidth={95} />}
          <Collection edit={lineHandoverReport.report.submitted === false && isLineSupervisorAdmin === true} background={false} collectionList={lineHandoverReport.report.assigned_employees} title="Line employees" nameProperty="name" idProperty="id" removeItem={(itemId: number) => onDeleteEmployeeLabour(itemId)} />
        </div>
        <div className="flex-1 min-w-0">
          {lineHandoverReport.report.submitted === false && isLineSupervisorAdmin && <EmployeeSearch place_holder={"Mc employees"} clearOnSelect fullUser={true} onSelectedEmployee={(employee: User | null) => onAddEmployeeLabourMC(employee)} inputWidth={95} />}
          <Collection edit={lineHandoverReport.report.submitted === false && isLineSupervisorAdmin === true} background={false} collectionList={lineHandoverReport.report.mc_employees} title="MC employees" nameProperty="name" idProperty="id" removeItem={(itemId: number) => onDeleteEmployeeLabourMC(itemId)} />
        </div>
      </div>
      <div className="flex flex-wrap justify-center">
        <Tabs
          tabNames={["Hidden", "Line Package", "Turn Checks"]}
          onChangeTabValue={(tabValue: number) => setTabValue(tabValue)}
          tabValue={tabValue}
        />
      </div>
      <LineHandoverMxiPackageInformation tabValue={tabValue} reportId={lineHandoverReport.report.id} />
      <Dialog
        visible={areYouSureDialogOpen}
        max_width={"md"} title={"Are you sure you want to finish this report"}
        context={
          <div></div>
        }
        onClose={(status: any) => onAreYouDialogClicked(status)}
        strict={false}
        show_options={true}
      />
    </div>
  );
};
export default HandoverDialogContext;